import { useState, useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchData } from './utils/functions';
import { itemShell } from './utils/form-data';
import { createNewStatus } from './utils/functions';
import StatusOption from './accessions/StatusOption';

const ChangeStatusPage = () => {
  const { itemId } = useParams();
  const queryClient = useQueryClient();
  const itemQuery = useQuery(['itemData', itemId], () => fetchData(`item/${itemId}`));
  const statusQuery = useQuery('statusData', () => fetchData(`status`));
  const salesChannelQuery = useQuery('salesChannelData', () => fetchData(`sales-channel`));
  const locationQuery = useQuery('locationData', () => fetchData(`location`));
  const [itemData, setItemData] = useState(null);
  const [statusData, setStatusData] = useState(null);
  const [salesChannelData, setSalesChannelData] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [error, setError] = useState('');
  const modifiedItemShell = {
    ...itemShell,
    statuses: itemShell.statuses.map((status) => ({
      ...status,
      status: {
        id: statusQuery.data.find((status) => status.name === "sold").id || 4,
        name: 'sold',
      },
    })),
  };
  const [itemStatusForm, setItemStatusForm] = useState(modifiedItemShell);
  const navigate = useNavigate();

  function findLocationNameById(locations, id) {
    const location = locations.find((location) => location.id === id);
    return location ? location.name : null;
  }

  useEffect(() => {
    console.log(statusQuery.data)
    if (itemQuery.data && statusQuery.data && salesChannelQuery.data && locationQuery.data) {
      setItemData(itemQuery.data[0]);
      const name = findLocationNameById(locationQuery.data, itemQuery.data[0].location_id) || '';
      setItemStatusForm((prevData) => ({
        ...prevData,
        id: itemQuery.data[0].id,
        location: {
          id: itemQuery.data[0].location_id,
          name
        }
      }));
      setStatusData(statusQuery.data);
      setSalesChannelData(salesChannelQuery.data);
      setLocationData(locationQuery.data);
    }
  }, [itemQuery.data, statusQuery.data, salesChannelQuery.data, locationQuery.data]);

  const handleSubmit = async () => {
    try {
      await createNewStatus(itemStatusForm, error, setError);
      if (!error) {
        queryClient.invalidateQueries('itemData');
        queryClient.invalidateQueries('statusData');
        queryClient.invalidateQueries('salesChannelData');
        queryClient.invalidateQueries('locationData');
        navigate(-1);
      }
    } catch (err) {
      setError(err);
    }
  };

  if (itemQuery.isLoading || statusQuery.isLoading || salesChannelQuery.isLoading || locationQuery.isLoading) {
    return 'Loading...';
  }

  if (itemQuery.isError || statusQuery.isError || salesChannelQuery.isError || locationQuery.isError) {
    return 'Error loading data';
  }

  return (
    <div>
      <h2>Change Status Page</h2>
      {itemData && (
        <div style={{ border: '1px solid #ccc', margin: '1%' }}>
          <StatusOption
            itemFormData={itemStatusForm}
            setItemFormData={setItemStatusForm}
            statusData={statusData}
            salesChannelData={salesChannelData}
            locationData={locationData}
          />
          <button onClick={handleSubmit}>Create Status</button>
        </div>
      )}
    </div>
  );
};

export default ChangeStatusPage;
